import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "../lib/icons";
import { useSettings } from "../context/SettingsContext";

export default function Navbar({ onRequest }) {
  const s = useSettings();
  return (
    <div style={{ borderBottom: "1px solid var(--line)", background: "var(--bg)" }}>
      <div className="wrap">
        <div className="bar">
          <Link className="brand" to="/"><BrandMark /><span>{s.brand}</span></Link>
          <nav className="links" aria-label="Main">
            <Link to="/fleet">Our fleet</Link>
            <Link to="/how-it-works">How it works</Link>
            <Link to="/about">About</Link>
            {onRequest ? <button className="cta" type="button" onClick={onRequest}>Request a flight</button> : <Link className="cta" to="/#top" style={{ textDecoration: "none" }}>Request a flight</Link>}
          </nav>
        </div>
      </div>
    </div>
  );
}
